import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-video',
    templateUrl: './video.component.html',
    styleUrls: ['./video.component.scss'],
    standalone: false
})
export class VideoComponent implements OnInit {
  @Input('p-title') title: string;
  @Input('p-date') date: string;
  @Input('p-url') url: string;
  @Input('p-url-id') urlId: string;

  constructor(
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
  }

  compartilharUrlViaWhatsapp() {
    const url = `https://api.whatsapp.com/send/?phone&text=${this.url}&app_absent=0`;
    window.open(url, '_blank')
  }

  abrirLinkDoYoutube() {
    window.open(this.url, '_blank')
  }

  limitChars(str: string, max: number) {
    if(str.length <= max)
      return str;
    else
      return str.slice(0, max) + '...';
  }

  getYoutubeEmbedUrl() {
    return `https://www.youtube.com/embed/${this.urlId}`;
  }
}